import React from "react";
import { Link } from "react-router-dom";
type SiteFooterProps = {
  tone?: "dark" | "warm";
  showLogo?: boolean;
};
const logoUrl = "https://cdn.magicpatterns.com/uploads/wXC3a9ND3anyvF39H6jMzb/NEW_LOGO_SMALL_PNG_FILE__(1)_(1).jpg";
export function SiteFooter({
  tone = "dark",
  showLogo = false
}: SiteFooterProps) {
  const isWarm = tone === "warm";
  return <footer className={`border-t px-6 py-7 sm:px-10 lg:px-14 ${isWarm ? "border-amber-700/70 bg-amber-950 text-amber-100" : "border-white/15 bg-stone-950 text-white/70"}`} data-id="element-50" data-mp="3hglp1ghqtsj6">
      <div className="mx-auto flex w-full max-w-7xl flex-col items-center gap-5 text-center" data-id="element-51" data-mp="33i5a529q8vpy">
        {showLogo && <img src={logoUrl} alt="Real Estate of Florida" className="h-auto w-40 bg-white sm:w-48" data-id="element-52" data-mp="2yknc46x900wq" />}
        <p className="text-xs font-medium tracking-wide sm:text-sm" data-id="element-53" data-mp="11q0o27ewssn5">
          © 2026 Teri Tangora Britton | Real Estate of Florida | {" "}
          <Link to="/privacy-policy" className={`underline underline-offset-4 transition-[color] duration-200 ${isWarm ? "decoration-amber-400 hover:text-white" : "decoration-white/50 hover:text-white"}`} data-id="element-54" data-mp="wqeatxz2zcec">
            Privacy Policy
          </Link>{" "}
          | {" "}
          <Link to="/terms-of-use" className={`underline underline-offset-4 transition-[color] duration-200 ${isWarm ? "decoration-amber-400 hover:text-white" : "decoration-white/50 hover:text-white"}`} data-id="element-55" data-mp="10qz4l1sjku06">
            Terms of Use
          </Link>
        </p>
        <p className="text-xs font-medium tracking-wide sm:text-sm" data-id="element-56" data-mp="1eqs1xfykq8h4">Equal Housing Opportunity</p>
        <a href="https://www.websitesbymandy.com" target="_blank" rel="noreferrer" className={`text-[10px] font-medium transition-[color] duration-200 ${isWarm ? "text-amber-100/65 hover:text-amber-50" : "text-white/45 hover:text-white/80"}`} data-id="element-57" data-mp="1jpbqzp8gs0dp">
          Made with a whole lot of grit by Trippin&apos; With Mandy™ LLC
        </a>
      </div>
    </footer>;
}